export const RECEIVE_TIMESLOT_DATA = 'RECEIVE_TIMESLOT_DATA';
export const SET_TIMESLOT_RULES = 'SET_TIMESLOT_RULES';
export const SAVE_TIMESLOT_RULES = 'SAVE_TIMESLOT_RULES';
// sauvegarde groupée : applique les mêmes rules à plusieurs produits en un seul POST
export const SAVE_TIMESLOT_RULES_BULK = 'SAVE_TIMESLOT_RULES_BULK';
export const RECEIVE_TIMESLOT_RULES = 'RECEIVE_TIMESLOT_RULES';

// édition globale (enabled + CRUD des timeslots)
// L'édition se fait dans un draft local au composant ; seule la sauvegarde touche le store.
export const SAVE_TIMESLOTS = 'SAVE_TIMESLOTS';
export const RECEIVE_TIMESLOTS = 'RECEIVE_TIMESLOTS';
export const RECEIVE_TIMESLOT_ENABLED = 'RECEIVE_TIMESLOT_ENABLED';
